import { ErrorCode } from './error-code'

export class ServerDelegator {
  constructor(con) {
    this._events = {}
    this._con = con
    this._invokeMap = {}
  }

  addModule(name, module) {
    this._events[name] = ((target, payload) => {
      try {
        const listener = module.onListener
        listener.bind(module)({ target, reqId: payload._req_id, payload, channel: this, broadcast: this.broadcast.bind(this) })
      } catch (e) {
        console.error('occurs error with module listener', e)
      }
    })
  }

  removeEventListener(event) {
    delete this._events[event]
  }

  async onData(json) {
    const targetModuleName = json['_to']
    if (targetModuleName && this._events[targetModuleName]) {
      const invokeId = json['_invoke']
      if (invokeId && invokeId > 0) {
        if (this._invokeMap[targetModuleName] && this._invokeMap[targetModuleName][invokeId]) {
          const returnValue = json['_return']
          const timerValue = this._invokeMap[targetModuleName][invokeId]['timer']
          if (timerValue !== 0 && timerValue !== ErrorCode.CHANNEL_TIMEOUT) {
            this._invokeMap[targetModuleName][invokeId]['resolve'](returnValue)
            clearTimeout(timerValue)
          }
          delete this._invokeMap[targetModuleName][invokeId]
        } else {
          console.error(`${targetModuleName}::${invokeId} invoke resolve not exitsts`)
        }
      } else {
        return this._events[targetModuleName](targetModuleName, json)
      }
    }
  }

  broadcast(event, payload) {
    if (!event || !payload) {
        throw Error('event or payload is null')
    }

    if (typeof payload !== 'object') {
        throw Error('only support by object type when broadcast')
    }

    return this._con.onData(event, payload)
  }

  invokeAction(from, payload) {
    return new Promise((resolve, reject) => {
      if (typeof payload['_action'] === 'undefined') {
        return resolve(ErrorCode.PARAM_IS_NULL)
      }

      if (typeof payload['_payload'] === 'undefined') {
          return resolve(ErrorCode.PARAM_IS_NULL)
      }

      if (typeof payload['_payload'] !== 'object') {
          return resolve(ErrorCode.PARAM_IS_INVALID_JSON)
      }

      if (!this._invokeMap[from]) {
        this._invokeMap[from] = {}
      }

      const invokeId = payload['_invoke']
      if (!this._invokeMap[from][invokeId]) {
        this._invokeMap[from][invokeId] = {
          resolve,
          'timer': 0
        }
      }
      this._invokeMap[from][invokeId]['timer'] = setTimeout(() => {
        if (this._invokeMap[from][invokeId]) {
          clearTimeout(this._invokeMap[from][invokeId]['timer'])
          this._invokeMap[from][invokeId]['timer'] = ErrorCode.CHANNEL_TIMEOUT
          resolve(ErrorCode.CHANNEL_TIMEOUT)
        }
      }, 60 *1000)
      this._con.onData('end-user', payload)
    })
  }
}
